const STATUS_KEYS: Record<string, string> = {
  PENDING: 'commission.status.pending',
  ACCEPTED: 'commission.status.accepted',
  REJECTED: 'commission.status.rejected',
  COMPLETED: 'commission.status.completed',
  SOLD: 'commission.status.sold',
  RETURNED_TO_CUSTOMER: 'commission.status.returned_to_customer',
  NEW: 'commission.status.new',
  RECEIVED_IN_STORE: 'commission.status.received_in_store',
};

export function commissionStatusToTranslationKey(status: string): string {
  return STATUS_KEYS[status] ?? 'commission.status.unknown';
}

export function translateCommissionStatus(status: string, t: (key: string) => string): string {
  return t(commissionStatusToTranslationKey(status));
}
